import { render, staticRenderFns } from "./onHeaderClick-editor.vue?vue&type=template&id=d635a814&scoped=true&"
import script from "./onHeaderClick-editor.vue?vue&type=script&lang=js&"
export * from "./onHeaderClick-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d635a814",
  null
  
)

export default component.exports